import React, { useState } from 'react';
import {
    Button,
    Card,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Col,
    Spinner,
    Row,
} from 'reactstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import logo from '../../assets/img/brand/logo.png';

const API_URL = 'http://localhost:3000';

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const resetPassword = async (token, newPassword) => {
        try {
            const response = await axios.post(`${API_URL}/resetPassword`, {
                token,
                newPassword,
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newPassword || !confirmPassword) {
            toast.error('Please fill in all fields.');
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }

        setLoading(true);
        try {
            await resetPassword(token, newPassword);
            toast.success('Password reset successfully.');
            navigate('/login');
        } catch (error) {
            toast.error(error?.message || 'Failed to reset password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Col lg="5" md="7">
                <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                        <Row className="align-items-center justify-content-center mb-4">
                            <Col xs="auto" className="px-2">
                                <img
                                    width={'150px'}
                                    src={logo}
                                    className="mx-auto d-block"
                                    alt=""
                                />
                            </Col>
                        </Row>
                        <div className="text-center text-muted mb-4">
                            <small>Reset Your Password</small>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        placeholder="New Password"
                                        type="password"
                                        name="newPassword"
                                        autoComplete="new-password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        placeholder="Confirm Password"
                                        type="password"
                                        name="confirmPassword"
                                        autoComplete="new-password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </InputGroup>
                            </FormGroup>
                            <div className="text-center">
                                <Button
                                    className="my-4"
                                    color="danger"
                                    disabled={loading}
                                    type="submit"
                                >
                                    {loading ? <Spinner size={'sm'} /> : 'Reset Password'}
                                </Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </>
    );
};

export default ResetPassword;